// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "paper-ToEz5";
export { _1 as "__esModule", _2 as "tablet", _3 as "paper" }
export default { "__esModule": _1, "tablet": _2, "paper": _3 }
